import HeadMassageImage from '../assets/images/Treatments/AyurvedicHeadMassage/head-massage-1.png';
import FaceMassageImage from '../assets/images/Treatments/AyurvedicFaceMassage/face-massage-1.png';
import FaceFacialImage from '../assets/images/Treatments/AyurvedicFacial/facial-1.png';
import NawarakizhiImage from '../assets/images/Treatments/Nawarakizhi/nawarakizhi-1.png';
import BodyMassageImage from '../assets/images/Treatments/AyurvedicBodyMassage/body-massage-1.png';
import BackMassageImage from '../assets/images/Treatments/AyurvedicBackMassage/back-massage-1.png';
import ShirodaraImage from '../assets/images/Treatments/Shirodara/shirodara-1.png';
import HandMassageImage from '../assets/images/Treatments/AyurvedicHandMassage/hand-massage-1.png';
import LegMassageImage from '../assets/images/Treatments/AyurvedicLegMassage/Leg-massage-1.png';
import FootMassageImage from '../assets/images/Treatments/AyurvedicFootMassage/foot-massage-1.png';
import NeckAndShoulderMassageImage from '../assets/images/Treatments/AyurvedicNeckAndShoulderMassage/neck-and-shoulder-massage-1.png';
// import AyurvedicSteamBathImage from '../assets/images/Treatments/AyurvedicSteamBath/steam-bath-2.jpg';


const TreatmentsData = [
    {
        id: 1,
        title: "Ayurvedic Head Massage",
        categoryName: 'Mind Relax',
        description:
            "Experience ultimate relaxation with our Ayurvedic Head Massage, an ancient rejuvenating therapy technique combines gentle, rhythmic strokes with the healing power of herbal oils to relieve stress, enhance circulation, and promote deep mental and physical relaxation. By targeting key pressure points on the scalp, neck, and shoulders, this massage helps reduce tension, improve sleep quality, and restore balance to your mind and body. Whether you seek relief from daily stress or simply wish to indulge in a moment of tranquility, our Ayurvedic Head Massage offers a holistic escape into serenity and well-being.",
        alt: "Head Massage Image",
        duration: "30 mins",
        price: "3250",
        src: HeadMassageImage,
        inclusions: [
            {
                id: 1,
                title: "Choose your comfort position",
                description: "Select either lying down of sitting to ensure your maximum comfort during the treatment."
            },
            {
                id: 2,
                title: "Nourishing medicinal oil application",
                description: "Warm herbal oil is gently applied to the scalp, nourishing the hair, balancing body heat, and calming the mind."
            },
            {
                id: 3,
                title: "Pressure point stimulation",
                description: "Key pressure points on the head are stimulated to improve circulation, release tension, and enhance mental clarity."
            },
            {
                id: 4,
                title: "Relaxing head massage",
                description: "Gentle yet effective massage techniques are used to reduce stress, improve sleep, and strengthen hair."
            },
            {
                id: 5,
                title: "Shoulder Massage",
                description: "A soothing massage focused exclusively on the shoulders to relieve stiffness, reduce stress, and improve circulation."
            },
            {
                id: 6,
                title: "Hot Towel Treatment",
                description: "A warm towel is applied to the head, enhancing oil absorption, releasing tension, and leaving you feeling refreshed."
            },
        ],
    },
    {
        id: 2,
        title: "Ayurvedic Face Massage",
        categoryName: 'Beauty',
        description:
            "Indulge in the rejuvenating benefits of our Ayurvedic Face Massage, a luxurious treatment technique that uses gentle, rhythmic strokes and herbal oils to nourish the skin, improve circulation, and enhance your natural glow. By stimulating key facial pressure points, it helps reduce tension, promote lymphatic drainage, and combat signs of aging. The soothing motions not only leave your skin feeling soft and radiant but also provide deep relaxation, easing stress and calming the mind. Experience a holistic approach to beauty that refreshes both your skin and spirit.",
        alt: "Face MAssage Image",
        duration: "30 mins",
        price: "3250",
        src: FaceMassageImage,
        inclusions: [
            {
                id: 1,
                title: "Nourishing Oil Application",
                description: "Warm herbal oil is gently applied to the face, delivering hydration and essential nutrients to your skin."
            },
            {
                id: 2,
                title: "Pressure Point Stimulation",
                description: "Key facial pressure points are carefully stimulated to boost circulation, promote lymphatic drainage, and release facial tension."
            },
            {
                id: 3,
                title: "Face and Neck Massage",
                description: "Relaxing massage techniques focus on the face and neck to smooth fine lines, improve skin texture, and relax muscles."
            },
            {
                id: 4,
                title: "Gentle Oil Removal",
                description: "Excess oil is removed using a soft, warm towel, leaving your skin clean, soft, and radiant."
            }
        ],
    },
    {
        id: 3,
        title: "Ayurvedic Facial",
        categoryName: 'Beauty',
        description:
            "Experience the ultimate skin rejuvenation with our Ayurvedic Facial, a luxurious treatment under our Beauty category. This holistic therapy blends time-honored techniques with natural, herbal ingredients to deeply cleanse, hydrate, and revitalize your skin. Designed to restore balance, improve circulation, and enhance your natural radiance, it gently removes impurities while promoting a youthful glow. The soothing massage techniques stimulate vital energy points, reducing stress and leaving your skin feeling refreshed and renewed. Embrace the power of Ayurveda for a facial that nurtures both your beauty and well-being.",
        alt: "Face Facial Image",
        duration: "1 hour",
        price: "6500",
        src: FaceFacialImage,
        inclusions: [
            {
                id: 1,
                title: "Cleansing the Face",
                description: "The treatment begins with a gentle cleansing using natural Ayurvedic cleansers to remove impurities, makeup, and excess oils from the skin."
            },
            {
                id: 2,
                title: "Cleaning Face After Cleansing",
                description: "The face is then wiped clean to ensure complete removal of the cleanser and any residual impurities."
            },
            {
                id: 3,
                title: "Herbal Oil or Bee Honey Massage",
                description: "Depending on your skin type and condition, an Ayurvedic massage using warm herbal oil or natural bee honey is applied to nourish and soothe the skin."
            },
            {
                id: 4,
                title: "Steam or Hot Towel Application",
                description: "Steam or a warm towel is applied to the face to help open the pores, making it easier for the active ingredients to penetrate and perform their rejuvenating effects."
            },
            {
                id: 5,
                title: "Herbal Scrub Application",
                description: "A gentle herbal scrub is applied to the face, using circular motions to exfoliate and remove dead skin cells."
            },
            {
                id: 6,
                title: "Cleaning the Scrub",
                description: "The scrub is gently wiped away using a soft, damp cloth."
            },
            {
                id: 7,
                title: "Herbal Pack Application",
                description: "An Ayurvedic herbal face pack is applied to the skin to further nourish and balance. This blend typically includes ingredients like turmeric, sandalwood, and other natural herbs known for their antibacterial and skin-soothing properties."
            },
            {
                id: 8,
                title: "Pack Removal",
                description: "After a few minutes to allow the pack to dry and work its magic, it is gently removed using warm water."
            },
            {
                id: 9,
                title: "Herbal Toner Application",
                description: "A soothing herbal toner is applied to help balance the skin's pH, close pores, and refresh the complexion."
            }
        ],
    },
    {
        id: 4,
        title: "Ayurvedic Neck and Shoulder Massage",
        categoryName: 'Touch',
        description:
            "Ease tension and restore balance with our Ayurvedic Neck and Shoulder Massage, a soothing treatment under our Beauty category. This revitalizing therapy uses gentle yet effective massage techniques combined with nourishing herbal oils to relieve stiffness, improve circulation, and enhance flexibility. By targeting key pressure points, it helps reduce stress, release built-up tension, and promote better posture. Whether you’re seeking relief from daily strain or simply want to indulge in relaxation, this massage offers a holistic approach to well-being, leaving you feeling light, refreshed, and completely rejuvenated.",
        alt: " Neck and Shoulder Massage Image",
        duration: "30 mins",
        price: "3250",
        src: NeckAndShoulderMassageImage,
        inclusions: [
            {
                id: 1,
                title: "Oil Application",
                description: "A warm, herbal oil is gently applied to your neck and shoulders, providing deep nourishment and preparing the muscles for relaxation."
            },
            {
                id: 2,
                title: "Pressure Point Stimulation",
                description: "Our therapist will stimulate key pressure points on your neck and shoulders, easing tension and promoting energy flow throughout the body."
            },
            {
                id: 3,
                title: "Neck Massage",
                description: "Gentle, targeted massage techniques are applied to your neck to alleviate tightness, improve circulation, and reduce discomfort."
            },
            {
                id: 4,
                title: "Shoulder Massage",
                description: "The shoulders are massaged with precise techniques that focus on relaxing tight muscles and restoring flexibility."
            }
        ],
    },
    {
        id: 5,
        title: "Ayurvedic Hand Massage",
        categoryName: 'Health',
        description:
            "Let your hands unwind and rejuvenate with our Ayurvedic Hand Massage, a therapeutic escape under our Health category. More than just a simple massage, this ancient healing ritual awakens tired hands, melts away stiffness, and restores vitality from your shoulders to your fingertips. Warm, herbal-infused oils seep deep into the skin, enhancing circulation while skilled hands work their magic, releasing built-up stress and tension. Whether you're typing away at a desk, crafting with passion, or simply seeking a moment of pure relaxation, this treatment breathes new life into your hands—leaving them lighter, softer, and blissfully renewed.",
        alt: "Hand Massage Image",
        duration: "30 mins",
        price: "3250",
        src: HandMassageImage,
        inclusions: [
            {
                id: 1,
                title: "Oil Application",
                description: "Warm, herbal oil is gently applied to your hands and arms to soften the skin and prepare the muscles for deep relaxation."
            },
            {
                id: 2,
                title: "Pressure Point Stimulation (Shoulder Joint to Fingers)",
                description: "Targeted pressure points from the shoulders down to the fingers are stimulated to release tension and promote energy flow throughout the arms."
            },
            {
                id: 3,
                title: "Finger Massage",
                description: "Each finger is massaged with care to relieve tension, improve flexibility, and encourage better blood flow."
            },
            {
                id: 4,
                title: "Palm Massage",
                description: "The palms of the hands are massaged using gentle yet effective techniques to release tightness and improve energy flow."
            },
            {
                id: 5,
                title: "Arm Massage",
                description: "A soothing massage is applied to the arms, from the elbows to the wrists, using smooth, flowing movements to ease tension and increase circulation."
            },
            {
                id: 6,
                title: "Massage for Forearms and Elbows",
                description: "The forearms and elbows are massaged with deeper pressure to target any areas of stiffness or discomfort."
            }
        ],
    },
    {
        id: 6,
        title: "Ayurvedic Back Massage",
        categoryName: 'Health',
        description:
            "Unwind and reset with our Ayurvedic Back Massage, a deeply therapeutic experience under our Health category. Designed to melt away tension and restore harmony, this ancient healing ritual focuses on the lumbar region, upper back, shoulders, and neck—where stress and fatigue often linger. Warm herbal oils seep into tired muscles as skilled hands work through knots and stiffness, improving flexibility and circulation. Each soothing stroke dissolves stress, leaving you feeling weightless, refreshed, and completely renewed. Whether you seek relief from daily strain or a moment of pure relaxation, this massage is your gateway to total well-being.",
        alt: "Back Massage Image",
        duration: "30 mins",
        price: "3250",
        src: BackMassageImage,
        inclusions: [
            {
                id: 1,
                title: "Oil Application",
                description: "Warm herbal oil is applied to your back, infusing the skin and muscles with nourishment and preparing the area for a soothing massage."
            },
            {
                id: 2,
                title: "Pressure Point Stimulation (Lumbar Region to Neck)",
                description: "Key pressure points from the lower back (lumbar region) to the neck are carefully stimulated, releasing deep-seated tension and improving energy flow."
            },
            {
                id: 3,
                title: "Massage (Bottom to Top of the Back)",
                description: "The back is massaged using flowing upward strokes, focusing on releasing tension in the muscles and promoting better posture."
            },
            {
                id: 4,
                title: "Shoulder Massage",
                description: "The shoulders are massaged with precision to alleviate tightness and restore movement."
            },
            {
                id: 5,
                title: "Neck Massage",
                description: "A soothing neck massage is performed to relax the upper neck muscles and relieve tension."
            }
        ],
    },
    {
        id: 7,
        title: "Ayurvedic Leg Massage",
        categoryName: 'Touch',
        description:
            "Step into pure relaxation with our Ayurvedic Leg Massage, a revitalizing therapy under our Health category. Designed to awaken tired legs and restore vitality, this treatment blends rhythmic strokes with warm, herbal-infused oils to boost circulation and dissolve fatigue. From your feet to your knees and beyond, each movement soothes soreness, eases tension, and brings a renewed sense of balance. Whether you're on your feet all day or simply craving deep relaxation, this massage melts away stress, leaving your legs lighter, energized, and ready to carry you forward with ease.",
        alt: "Leg Massage Image",
        duration: "30 mins",
        price: "3250",
        src: LegMassageImage,
        inclusions: [
            {
                id: 1,
                title: "Oil Application",
                description: "Warm herbal oil is gently applied to the legs, preparing the skin and muscles for the massage."
            },
            {
                id: 2,
                title: "Massage from Feet to Inguinal Region (Back of the Leg)",
                description: "Gentle, rhythmic strokes are applied from the soles of the feet to the upper thigh along the back of the leg."
            },
            {
                id: 3,
                title: "Massage from Feet to Inguinal Region (Front of the Leg)",
                description: "Soothing strokes focus on the quadriceps and shin area."
            },
            {
                id: 4,
                title: "Knee Joint Massage",
                description: "Special attention is given to the knee joint using circular motions."
            },
            {
                id: 5,
                title: "Foot Massage",
                description: "The massage concludes with focused care on the feet, including the arches, heels, and toes."
            }
        ],
    },
    {
        id: 8,
        title: "Ayurvedic Foot Massage",
        categoryName: 'Touch',
        description:
            "Treat your feet to the ultimate relaxation with our Ayurvedic Foot Massage, a rejuvenating therapy under our Beauty category. This soothing ritual blends ancient techniques with herbal-infused oils to relieve tension, improve circulation, and restore harmony from the soles up. As skilled hands work through pressure points, stress melts away, leaving your feet lighter, your legs refreshed, and your entire body rebalanced. Whether you've been on the move all day or simply crave a moment of pure bliss, this indulgent treatment offers the perfect escape—one step at a time.",
        alt: "Foot Massage Image",
        duration: "30 mins",
        price: "3250",
        src: FootMassageImage,
        inclusions: [
            {
                id: 1,
                title: "Oil Application",
                description: "Warm herbal oil is gently applied to the feet and lower legs, preparing the skin and muscles for a deeply relaxing and therapeutic massage."
            },
            {
                id: 2,
                title: "Pressure Point Stimulation (Foot)",
                description: "Key reflexology points on the feet are carefully stimulated to release tension, improve energy flow, and restore balance throughout the body."
            },
            {
                id: 3,
                title: "Foot Massage (Below the Knee)",
                description: "Smooth, rhythmic strokes are applied from the feet up to the area below the knee, focusing on relieving muscle tension, improving circulation, and revitalizing the lower legs."
            },
            {
                id: 4,
                title: "Toe Massage",
                description: "Each toe is individually massaged with care to relieve tightness, improve flexibility, and promote deep relaxation."
            },
            {
                id: 5,
                title: "Herbal Foot Bath (15 Minutes)",
                description: "The massage concludes with a rejuvenating herbal foot bath, where your feet are soaked in warm water infused with a blend of Ayurvedic herbs."
            }
        ],
    },
    // {
    //     id: 9,
    //     title: "Ayurvedic Full Body Massage",
    //     categoryName: 'Luxurious Experience',
    //     description:
    //         "Immerse yourself in pure tranquility with our Ayurvedic Full Body Massage, a luxurious escape under our Health category. This ancient healing ritual envelops you in the warmth of herbal-infused oils, melting away stress and fatigue from head to toe. Gentle yet invigorating strokes improve circulation, ease muscle tension, and restore the body’s natural harmony. As skilled hands work in sync with centuries-old techniques, you’ll feel a profound sense of relaxation, rejuvenation, and inner balance. More than just a massage—it’s a journey of renewal for your body, mind, and soul.",
    //     alt: "Full Body Massage Image",
    //     duration: "30 mins",
    //     price: "3500",
    //     src: BodyMassageImage,
    //     inclusions: [
    //         {
    //             id: 1,
    //             title: "Warm-Up with Gentle Touch",
    //             description: "The therapist begins by gently warming up your body with soft strokes, helping to relax the muscles and prepare your body for deeper work."
    //         },
    //         {
    //             id: 2,
    //             title: "Oil Application on Back",
    //             description: "Warm herbal oil is applied to your back, softening the skin and preparing the muscles for relaxation."
    //         },
    //         {
    //             id: 3,
    //             title: "Back Massage (Lumbar Region to Neck)",
    //             description: "The therapist massages the back from the lumbar region (lower back) to the neck using deep strokes to release tension and tightness."
    //         },
    //         {
    //             id: 4,
    //             title: "Hip to Foot Massage (Back of the Leg)",
    //             description: "Flowing strokes are applied from the hips to the feet, focusing on relaxation and relieving tension in the legs."
    //         },
    //         {
    //             id: 5,
    //             title: "Abdominal Massage",
    //             description: "Warm oil is gently applied to the abdominal area, followed by pressure point stimulation and circular massage to promote digestion and relaxation."
    //         },
    //         {
    //             id: 6,
    //             title: "Front Side of Leg Massage (From Foot to Inguinal Region)",
    //             description: "Herbal oil is applied to the front of the legs, followed by pressure point stimulation and rhythmic massage strokes to relieve soreness and improve flexibility."
    //         },
    //         {
    //             id: 7,
    //             title: "Hand Massage",
    //             description: "Herbal oil is applied to the hands and wrists, followed by pressure point stimulation and a gentle massage focusing on the fingers, palms, and wrists."
    //         },
    //         {
    //             id: 8,
    //             title: "Neck Massage",
    //             description: "Herbal oil is applied to the neck, followed by soothing massage strokes to release tension and improve posture."
    //         },
    //         {
    //             id: 9,
    //             title: "Head Massage",
    //             description: "Warm herbal oil is gently massaged into the scalp, with pressure point stimulation and soothing massage techniques to relieve stress and promote relaxation."
    //         }
    //     ],
    // },
    // {
    //     id: 10,
    //     title: "Ayurvedic Steam Bath",
    //     categoryName: 'Beauty',
    //     description:
    //      "Step into serenity with our Ayurvedic Steam Bath, a rejuvenating experience under our Beauty category. Enveloped in the soothing warmth of herbal-infused steam, this therapeutic treatment opens your pores, allowing toxins to be released while deeply nourishing your skin. The gentle, purifying heat encourages relaxation, enhances circulation, and revitalizes your body from the inside out. As you unwind in this luxurious bath, your body is detoxified, your mind is calmed, and your spirit is renewed. Perfect for those seeking a holistic path to wellness and radiant, refreshed skin.",
    //     alt: "",
    //     duration:"30 mins",
    //     price:"3500",
    //     src: AyurvedicSteamBathImage,
    // },
    // {
    //     id: 11,
    //     title: "Ayurvedic Body Scrub Therapy",
    //     categoryName: 'Beauty',
    //     description:
    //         "Reveal your skin’s natural glow with our Ayurvedic Body Scrub Therapy, a luxurious treatment under our Beauty category. This indulgent full-body exfoliation uses a blend of gentle herbal scrubs to sweep away dead skin cells, leaving your skin soft, smooth, and renewed. As the scrub works its magic, it enhances circulation, promotes lymphatic drainage, and nourishes the skin with rich, natural ingredients. With each stroke, feel a sense of rejuvenation as your skin is cleansed, refreshed, and infused with a radiant, youthful glow. Perfect for those seeking a holistic approach to beauty and well-being.",
    //     alt: "",
    //     duration:" mins",
    // price:"",
    // src: "",
    // },
    // {
    //     id: 12,
    //     title: "Full Body Herbal Fomentation",
    //     categoryName: 'Beauty',
    //     description:
    //         "Experience the ultimate relaxation with our Full Body Herbal Fomentation, a luxurious Ayurvedic therapy under our Beauty category. This transformative treatment uses warm herbal poultices to deliver soothing, deep compression to your muscles, providing unparalleled relief while rejuvenating your skin. As the herbs work their magic, circulation is enhanced, toxins are gently flushed out, and your body is restored to its natural balance. With each comforting application, feel your stress melt away, leaving you refreshed, revitalized, and glowing. A truly holistic experience for those seeking deep relaxation and radiant well-being.",
    //     alt: "",
    //     duration:" mins",
    // price:"",
    // src: "",
    // },
    // {
    //     id: 13,
    //     title: "Full Body Herbal Pack",
    //     categoryName: 'Luxurious Experience',
    //     description:
    //         "Indulge in the healing touch of Ayurveda with our Full Body Herbal Pack, a deeply revitalizing treatment under our Beauty category. This natural therapy envelops your entire body in a luxurious herbal blend, carefully crafted to detoxify, nourish, and rejuvenate the skin. Rich in Ayurvedic ingredients, the pack penetrates deep into the skin, restoring balance, enhancing hydration, and promoting a radiant glow. As the herbal goodness works its magic, you’ll feel your stress melt away, leaving you with refreshed, glowing skin and a renewed sense of well-being. A perfect holistic experience for inner and outer radiance.",
    //     alt: "",
    //     duration:" mins",
    // price:"",
    // src: "",
    // },
    // {
    //     id: 14,
    //     title: "Full Body Herbal Wrap",
    //     categoryName: 'Luxurious Experience',
    //     description:
    //         "Unveil total body rejuvenation with our Full Body Herbal Wrap, an indulgent Ayurvedic experience under our Beauty category. This luxurious treatment combines the nourishing power of herbal packs with the natural insulation of banana leaves, creating a serene, enveloping wrap that enhances the absorption of potent Ayurvedic ingredients. As the warmth and herbs work in harmony, your skin is deeply nourished, detoxified, and rejuvenated, leaving it soft, radiant, and refreshed. This holistic therapy not only restores your skin’s natural glow but also provides a blissfully relaxing experience, ensuring both body and mind are renewed.",
    //     alt: "",
    //     duration:" mins",
    // price:"",
    // src: "",
    // },
    // {
    //     id: 15,
    //     title: "Ayurvedic Head Wrap",
    //     categoryName: 'Health',
    //     description:
    //         "Immerse yourself in the soothing embrace of our Ayurvedic Head Wrap, a rejuvenating ritual under our Beauty category. This therapeutic treatment envelops your scalp in a nourishing herbal blend, rich in Ayurvedic botanicals that deeply condition, strengthen hair, and promote a sense of tranquility. Wrapped in the gentle insulation of banana leaves, the herbs penetrate deeply, enhancing absorption for maximum benefits. As warmth and nature’s essence work their magic, tension melts away, mental clarity is restored, and your scalp feels revitalized. A perfect fusion of relaxation and hair wellness, leaving you refreshed from root to mind.",
    //     alt: "",
    //     duration:" mins",
    // price:"",
    // src: "",
    // },
    {
        id: 16,
        title: "Shirodhara Treatment",
        categoryName: 'Mind Relax',
        description:
            "Drift into a state of deep serenity with our Shirodhara Treatment, an exquisite Ayurvedic ritual. A continuous stream of warm, herb-infused oil cascades over your forehead, melting away mental fatigue, soothing the senses, and bringing clarity to the mind. Paired with a gentle head massage, this therapy quiets restlessness, balances emotions, and restores inner harmony. As the rhythmic flow lulls you into pure relaxation, stress dissolves, leaving you in a blissful state of renewal—where tranquility and rejuvenation become one.",
        alt: "Shirodara Image",
        duration: "1 hour",
        price: "11700",
        src: ShirodaraImage,
        inclusions: [
            {
                id: 1,
                title: "Preparation of Medicated Oil",
                description: "A special blend of herbal oils, such as sesame oil or medicated oils infused with herbs like Brahmi, are heated to a comfortable temperature for the treatment."
            },
            {
                id: 2,
                title: "Abhyanga (Oil Massage)",
                description: "Before Shirodhara, the body is massaged with warm herbal oils to prepare the body and induce a state of relaxation."
            },
            {
                id: 3,
                title: "Shirodhara Procedure",
                description: "Warm, medicated oil is poured in a gentle, continuous stream over the forehead, specifically targeting the 'third eye' (Ajna chakra). The oil is allowed to flow for about 30-40 minutes."
            },
            {
                id: 4,
                title: "Relaxation and Absorption",
                description: "After the Shirodhara, the individual is allowed to rest for a few minutes to absorb the full benefits of the treatment."
            },
            {
                id: 5,
                title: "Post-Treatment Care",
                description: "After the therapy, the hair is gently washed to remove any excess oil, and the person is advised to avoid any exposure to cold or harsh environments."
            }
        ],
    },

    // {
    //     id: 17,
    //     title: "Nasna Treatment",
    //     categoryName: 'Mind Relax',
    //     description:
    //         "Breathe freely and restore balance with our Nasna Treatment, a time-honored Ayurvedic therapy designed to purify and revitalize the nasal passages. This gentle yet powerful treatment uses medicated herbal oils to clear congestion, enhance respiratory function, and soothe discomfort in the head and neck. Perfect for those struggling with sinus issues, migraines, or mental fatigue, Nasna works to release toxins, improve oxygen flow, and bring a sense of clarity and calm. Experience the power of deep healing as your senses awaken, stress melts away, and your mind feels refreshed and renewed.",
    //     alt: "",
    //     duration:" mins",
    // price:"",
    // src: "",
    // },
    // {
    //     id: 18,
    //     title: "Stress Relief Fomentation Therapy",
    //     categoryName: 'Mind Relax',
    //     description:
    //         "Melt away tension and restore inner calm with our Stress Relief Fomentation Therapy, a deeply soothing Ayurvedic treatment designed to ease stress, muscle stiffness, and fatigue. Warm herbal compresses (Pottani), infused with the healing essence of Adenanthera pavonina seeds, are gently applied to targeted areas, allowing heat and therapeutic herbs to penetrate deep into the muscles. This fusion of warmth and pressure enhances circulation, releases built-up tension, and promotes a profound sense of relaxation. As stress dissipates and the body unwinds, you'll emerge feeling refreshed, rebalanced, and completely rejuvenated.",
    //     alt: "",
    //     duration:" mins",
    // price:"",
    // src: "",
    // },
    // {
    //     id: 19,
    //     title: "Full body Stretching Therapy",
    //     categoryName: 'Touch',
    //     description:
    //         "Restore movement and vitality with our Full Body Stretching Therapy, an invigorating Ayurvedic treatment designed to enhance flexibility, ease stiffness, and improve joint mobility. Through a series of guided stretches and therapeutic movements, this therapy targets key joints along the front and back of the body, releasing built-up tension and encouraging natural alignment. As muscles elongate and circulation increases, you’ll experience a newfound sense of lightness, balance, and relaxation. Perfect for those seeking to restore mobility, prevent stiffness, or simply reconnect with their body’s natural flow.",
    //     alt: "",
    //     duration:" mins",
    // price:"",
    // src: "",
    // },
    {
        id: 20,
        title: "Nawarakizhi",
        categoryName: 'Luxurious Experience',
        description: 
            "Experience the rejuvenating essence of Nawarakizhi, a deeply nourishing Ayurvedic therapy that blends rhythmic massage with the healing power of medicated rice boluses. Warm bundles infused with herbal decoctions and milk are gently pressed over the body, promoting deep relaxation, enhancing skin vitality, and revitalizing tired muscles. This luxurious treatment not only soothes the senses but also nurtures the skin, leaving it soft, supple, and radiant. As warmth seeps into every pore, stress fades away, and a profound sense of renewal washes over you—restoring balance, energy, and inner harmony.",
        alt: "Body Massage Image",
        duration: "1 hour",
        price: "10400",
        src: NawarakizhiImage,
        inclusions: [
            {
                id: 1,
                title: "Preparation of Herbal Rice Poultices",
                description: "A special type of medicinal rice (Navara) is cooked with herbal decoctions and milk, then tied into small poultices (boluses) for application."
            },
            {
                id: 2,
                title: "Oil Application (Abhyanga)",
                description: "Warm herbal oil is applied to the body in gentle strokes to prepare the skin and muscles for the therapy."
            },
            {
                id: 3,
                title: "Therapeutic Massage with Rice Poultices",
                description: "The heated rice boluses are massaged over the body using rhythmic strokes, focusing on areas of tension and discomfort."
            },
            {
                id: 4,
                title: "Sweating Therapy (Swedana)",
                description: "As the warm rice poultices are applied, the body undergoes therapeutic sweating, which helps in deep absorption of nutrients and detoxification."
            },
            {
                id: 5,
                title: "Final Cleansing and Rest",
                description: "After the massage, excess oil and herbal residues are gently wiped away, and the body is allowed to rest to absorb the full benefits of the treatment."
            }
        ],
    },
];

export default TreatmentsData;